import {JsonProperty} from 'json-typescript-mapper';
import {PrivacyPolicy} from './privacy-policy.model';

export class PrivacyPolicyAgreement {
  @JsonProperty('id')
  public id?: number;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('updated')
  public updated?: string;

  @JsonProperty('userId')
  public userId?: number;

  @JsonProperty('ipAddress')
  public ipAddress?: string;

  @JsonProperty('privacyPolicy')
  public privacyPolicy?: PrivacyPolicy;

  constructor() {
    this.id = void 0;
    this.created = void 0;
    this.updated = void 0;
    this.userId = void 0;
    this.ipAddress = void 0;
    this.privacyPolicy = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/privacy-policy-agreement.model.ts